module.exports = __webpack_public_path__ + "img/23.9aae7e4e.svg";